import { useEffect, useRef, useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import allImgPaths from "../../assets";
import { useAppState } from "../../context";
import useOutsideClick from "../../hooks/useOutsideClick";
// interface HeaderProps {
//   collapsed?: boolean;
//   setCollapsed?: (collapsed: boolean) => void;
// }

const Header = () => {
  //console.log("Header");

  const { isLoggedIn, getLatestUserData, logout, clearAuthState } =
    useAppState("auth");
  const { clearState, clearAllDashboardData } = useAppState("teammember");
  const userData: any = getLatestUserData() || {};
  const [isOpen, setIsOpen] = useState(false);
  const actionsRef = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    const callLogout = async () => {
      if (!isLoggedIn) {
        if (await logout()) {
          navigate("/");
        }
      }
    };
    callLogout();
  }, [isLoggedIn]);

  useOutsideClick(actionsRef, (): void => {
    isOpen && setIsOpen((prev) => !prev);
  });

  const onLogout = async () => {
    // if (await logout()) {
    localStorage.clear();
    clearState();
    clearAuthState();
    clearAllDashboardData();
    navigate("/login");
    // }
  };

  // const userRoleId = userData?.currentAccount?.userRole?._id;
  // const roleConfigIds = userData.roleConfigs?.configObj?.map(
  //   (config: any) => config.roleName === "superAdmin" && config.roleId,
  // );
  // const filterRoles = ["superAdmin", "member"];
  // const roleConfigIds =
  //   (userData?.roleConfigs?.configObj || userData?.roleConfigs)
  //     ?.filter((config: any) => filterRoles.includes(config.roleName))
  //     .map((config: any) => config.roleId) || [];

  // const [accounts, setAccounts]: any = useState();

  const [shouldDisplayStateCard] = useState(false);
  // const userRoles = async () => {
  //   if (!Array.isArray(accounts)) {
  //     const res = await getSwitchRoles(userData?._id);

  //     setAccounts(res?.data?.data?.userRoleMap); // Set the roles data

  //     const filterValidAccount = res?.data?.data?.userRoleMap.filter(
  //       (ele: any) => !roleConfigIds.includes(ele.userRole._id),
  //     );

  //     const excludeRoles = roleConfigIds.includes(userRoleId);
  //     setShouldDisplayCard(
  //       excludeRoles ? false : filterValidAccount.length > 1,
  //     );
  //   }
  // };
  // useEffect(() => {
  //   userRoles();
  // }, []);

  return (
    <div className="px-[30px] w-full">
      <div className="flex items-center justify-between w-full text-blue-500">
        {/* <button onClick={() => setCollapsed && setCollapsed(!collapsed)}>
          {collapsed ? <FaChevronRight /> : <FaChevronLeft />}
        </button> */}
        {/* <Button
          type="text"
          icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
          onClick={() => setCollapsed && setCollapsed(true)}
          style={{
            fontSize: "16px",
          }}
        /> */}
        <div className="h-10 flex items-center justify-end w-full">
          <img
            src={
              userData.profileUrl
                ? `${process.env.REACT_APP_API_URL}/api/users/profileImage/${userData.profileUrl}`
                : allImgPaths.profileIcon
            }
            onClick={() => setIsOpen((prev) => !prev)}
            alt={"ProfileIcon"}
            className="w-[35px] h-[35px] rounded-full cursor-pointer "
          />
        </div>

        <div className="relative inline-block text-left" ref={actionsRef}>
          <div>
            <div
              className={`${isOpen ? `block` : `hidden`} absolute right-[-28px] z-10 mt-5 w-40 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none`}
              role="menu"
              aria-orientation="vertical"
              aria-labelledby="menu-button"
              tabIndex={-1}
            >
              <div className="py-1" role="none">
                {/* {userData} */}
                {shouldDisplayStateCard && (
                  <NavLink
                    to="/switch-profile"
                    className="text-gray-700 px-4 py-2 text-sm flex justify-between"
                  >
                    Switch Profile
                    <img
                      className="-mr-1 h-5 w-5 text-gray-400 -rotate-90"
                      src={allImgPaths.editDownArrow}
                      alt=""
                    />
                  </NavLink>
                )}
                {/* <NavLink
                  to="/switch-profile"
                  className="text-gray-700 px-4 py-2 text-sm flex justify-between"
                >
                  Switch Profile
                  <img
                    className="-mr-1 h-5 w-5 text-gray-400 -rotate-90"
                    src={allImgPaths.editDownArrow}
                    alt=""
                  />
                </NavLink> */}
                {/* <NavLink
                  to="/profile"
                  className="text-gray-700 px-4 py-2 text-sm flex justify-between"
                >
                  My Profile
                  <img
                    className="-mr-1 h-5 w-5 text-gray-400 -rotate-90"
                    src={allImgPaths.editDownArrow}
                    alt=""
                  />
                </NavLink> */}
                <div className="p-3">
                  <div onClick={() => onLogout()}>
                    <button
                      type="button"
                      className="w-full focus:outline-none text-white bg-[#00A48B] font-medium rounded-lg text-sm px-5 py-2.5"
                      role="menuitem"
                      tabIndex={-1}
                      id="menu-item-3"
                    >
                      Logout
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Header;
